// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1IdentityUpdateSchema = z.object({
  user: z.object({
    name: z.optional(z.coerce.string().min(1)),
    email: z.optional(z.coerce.string().min(1)),
    time_zone: z.optional(z.coerce.string().min(1).describe("User timezone identifier (e.g., \"America/New_York\")")),
    active: z.optional(z.boolean()),
    avatar: z.optional(z.coerce.string().min(1).describe("Base64 encoded avatar image or image file")),
    day_view_onboarded: z.optional(z.boolean()),
    memory_onboarded: z.optional(z.boolean()),
    date_format: z.coerce.string().describe("User preferred date format").nullish(),
    time_format: z.coerce.string().describe("User preferred time format").nullish(),
    secondary_email: z.coerce.string().describe("Secondary email address for notifications").nullish(),
    memory_retention_days: z.number().int().min(0).describe("Number of days to retain memory data").nullish(),
  }),
});
